/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


export class SessionStorage {

  static questionIndexKey = 'overview-questionIndex'

  static getQuestionIndex() {
    return window.sessionStorage.getItem(SessionStorage.questionIndexKey);
  }

  static setQuestionIndex(questionIndex: string | number) {
    window.sessionStorage.setItem(SessionStorage.questionIndexKey, String(questionIndex));
  }

  static deleteQuestionIndex() {
    window.sessionStorage.removeItem(SessionStorage.questionIndexKey);
  }

}
